import * as serviceAPI from '@/api/service'

// 获取营业网点的列表
export function fetchServicePointList(coor) {

    const coordinate = new Object()
    coordinate.origin = coor

    return new Promise(function(resolve, reject){
        serviceAPI.getServicePointList(coordinate)
            .then(function(result) {
                resolve(result.data.list)
            })
    })
}
// 获取营销网点的列表
export function fetchServicePointList2(coor) {

    const coordinate = new Object()
    coordinate.origin = coor

    return new Promise(function(resolve, reject){
        serviceAPI.getServicePointList2(coordinate)
            .then(function(result) {
                resolve(result.data.list)
            })
    })
}
// 获取banner图
export function fetchBanner() {

	const param = {
		client: 0
	}

	return new Promise(function(resolve, reject){
		serviceAPI.getBanner(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.imgUrl = result.data

				resolve(responseBody)
			})
	})
}

// 获取营销与服务 海外市场内容
export function fetchOverseas() {

	const param = {
		type: 2,
		language: 'zh'
	}

	return new Promise(function(resolve, reject){
		serviceAPI.getService(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.content = result.data.content

				resolve(responseBody)
			})
	})
}

// 获取营销与服务 服务
export function fetchService() {

	const param = {
		type: 3,
		language: 'zh'
	}

	return new Promise(function(resolve, reject){
		serviceAPI.getService(param)
			.then(function(result) {

				// console.log(result)

				let responseBody = new Object()
				responseBody.content = result.data.content

				resolve(responseBody)
			})
	})
}

// 获取营销与服务 质量
export function fetchQuality() {

	const param = {
		type: 6,
		language: 'zh'
	}

	return new Promise(function(resolve, reject){
		serviceAPI.getService(param)
			.then(function(result) {

				// console.log(result)

				let responseBody = new Object()
				responseBody.content = result.data.content

				resolve(responseBody)
			})
	})
}
